import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import NetworkList from './components/NetworkList';
import LineList from './components/LineList';
import DirectionList from './components/DirectionList';
import Timetable from './components/Timetable';
import Admin from './pages/Admin';
import TestRealtimeData from './pages/TestRealtimeData';
import BottomNavBar from './components/BottomNavBar';
import Footer from './components/Footer';
import Login from './pages/Login';
import Register from './pages/Register';
import Account from './pages/Account';
import ResetPassword from './pages/ResetPassword';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { ToastProvider } from './context/ToastContext';
import DebugProfile from './pages/DebugProfile';
import Favorites from './pages/Favorites';
import Horaires from './pages/Horaires';
import Contact from './pages/Contact';
import Itineraries from './pages/Itineraries';
import PrivacyPolicy from './pages/PrivacyPolicy';
import LegalNotice from './pages/LegalNotice';
import WelcomeModal from './components/WelcomeModal';
import ProtectedAdminRoute from './components/ProtectedAdminRoute';
import { shouldShowWelcomeModal, markWelcomeModalAsShown } from './services/welcomeService';
import ScrollToTop from './components/ScrollToTop';
import './App.css';
import GoogleAnalytics from './components/GoogleAnalytics';
import usePageTracking from './hooks/usePageTracking';

function AppContent() {
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  usePageTracking();

  useEffect(() => {
    // Vérifier si la modal de bienvenue doit être affichée
    const shouldShow = shouldShowWelcomeModal();
    setShowWelcomeModal(shouldShow);
  }, []);

  const handleCloseWelcomeModal = () => {
    // Marquer la modal comme affichée pour cette version
    markWelcomeModalAsShown();
    setShowWelcomeModal(false);
  };

  return (
    <>
      <ScrollToTop />
      <div className="min-h-screen bg-gray-50 dark:bg-dark-900 flex flex-col pb-16 transition-colors duration-200">
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<NetworkList />} />
            <Route path="/network/:networkId/lines" element={<LineList />} />
            <Route path="/network/:networkId/line/:lineId/directions" element={<DirectionList />} />
            <Route path="/network/:networkId/line/:lineId/direction/:directionId/timetable" element={<Timetable />} />
            <Route path="/admin/*" element={<ProtectedAdminRoute><Admin /></ProtectedAdminRoute>} />
            <Route path="/test-realtime/:networkId/:lineId" element={<TestRealtimeData />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/account" element={<Account />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/debug-profile" element={<DebugProfile />} />
            <Route path="/favorites" element={<Favorites />} />
            <Route path="/horaires" element={<Horaires />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/itineraries" element={<Itineraries />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/legal-notice" element={<LegalNotice />} />
          </Routes>
        </div>
        <Footer />
        <BottomNavBar />
      </div>
      
      {/* Modal de bienvenue */}
      {showWelcomeModal && <WelcomeModal onClose={handleCloseWelcomeModal} />}
    </>
  );
}

function App() {
  const GA_MEASUREMENT_ID = 'G-3XW783VZ82';

  return (
    <ThemeProvider>
      <ToastProvider>
        <Router basename="/">
          <AuthProvider>
            <GoogleAnalytics measurementId={GA_MEASUREMENT_ID} />
            <AppContent />
          </AuthProvider>
        </Router>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
